/**
 * 日付フォーマット用ユーティリティ
 * toLocaleStringを使用せずに日付をフォーマット
 */

/**
 * 数値を2桁の文字列にパディング
 */
const padZero = (num: number, digits: number = 2): string => {
  return String(num).padStart(digits, '0');
};

/**
 * 日付をyyyy/MM/dd HH:mm:ss形式にフォーマット
 */
export const formatDateTime = (date: Date): string => {
  const year = date.getFullYear();
  const month = padZero(date.getMonth() + 1);
  const day = padZero(date.getDate());
  const hour = padZero(date.getHours());
  const minute = padZero(date.getMinutes());
  const second = padZero(date.getSeconds());

  return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
};

/**
 * 日付をMM/dd HH:mm:ss形式にフォーマット（年なし）
 */
export const formatDateTimeShort = (date: Date): string => {
  const month = padZero(date.getMonth() + 1);
  const day = padZero(date.getDate());
  const hour = padZero(date.getHours());
  const minute = padZero(date.getMinutes());
  const second = padZero(date.getSeconds());

  return `${month}/${day} ${hour}:${minute}:${second}`;
};

/**
 * 日付をMM/dd HH:mm形式にフォーマット（秒なし）
 */
export const formatDateTimeNoSeconds = (date: Date): string => {
  const month = padZero(date.getMonth() + 1);
  const day = padZero(date.getDate());
  const hour = padZero(date.getHours());
  const minute = padZero(date.getMinutes());

  return `${month}/${day} ${hour}:${minute}`;
};

/**
 * 日付をyyyy/MM/dd形式にフォーマット
 */
export const formatDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = padZero(date.getMonth() + 1);
  const day = padZero(date.getDate());

  return `${year}/${month}/${day}`;
};

/**
 * 時刻をHH:mm:ss形式にフォーマット
 */
export const formatTime = (date: Date): string => {
  const hour = padZero(date.getHours());
  const minute = padZero(date.getMinutes());
  const second = padZero(date.getSeconds());

  return `${hour}:${minute}:${second}`;
};

/**
 * デフォルトパディング桁数
 */
export const DATE_FORMAT_CONSTANTS = {
  DEFAULT_PADDING_DIGITS: 2,
} as const;